<template>
  <div id="app">
    <el-row  class="row-header" type="flex" justify="center" >
      <el-col :span="15" >
        <h2 class='header-h2'>{{ pj_name }}</h2>
      </el-col>
    </el-row>
    
    <el-row style="height:280px;background:#eeeeee" type="flex" justify="center" >
      <el-col :span="15">
        <br>
        <h2 style="font-size:50px" >Hello,{{ welcome }}</h2>
        <p>这是一个简单的营销或信息网站的模板。它包括一个名为jumbotron的大型标注和三个支持内容。把它作为一个起点来创造更独特的东西。</p>
        <el-button type="primary">了解更多 >></el-button>
      </el-col>
    </el-row>

    <el-row style="background:#eeeeee" type="flex" justify="center" >
      <el-col :span="15">
        <el-card shadow="never" v-for="(item,index) of datas" :key="index">
          <h2>{{item.heading}}</h2>
          <p class="cardp">{{item.card}}</p>
          <el-button size="small"  type="success">查看详细 >></el-button>
        </el-card>
      </el-col>
    </el-row>
         
    <el-row style="background:#eeeeee" type="flex" justify="center" >
      <el-col :span="15" >
        <el-divider></el-divider>
        <p>© 2022 杜老师工作室 版权所有.<a href="../index_du.html"><el-button type="success" ><i class="el-icon-position"></i>返回</el-button></a></p>
      </el-col>
    </el-row>

  </div>
</template>

<script>
import Vue from 'vue';
    export default {
        data() 
        {
            return {
                welcome: '杜老师',
                pj_name: 'Element-UI项目(杜老师)',
                datas:[{heading:'1. Java程序设计',card:'Java是一门面向对象的编程语言，不仅吸收了C++语言的各种优点，还摒弃了C++里难以理解的多继承、指针等概念，因此Java语言具有功能强大和简单易用两个特征。Java语言作为静态面向对象编程语言的代表，极好地实现了面向对象理论，允许程序员以优雅的思维方式进行复杂的编程。'},
                {heading:'2. Html/Css程序设计',card:'HTML的全称为超文本标记语言，是一种标记语言。它包括一系列标签．通过这些标签可以将网络上的文档格式统一，使分散的Internet资源连接为一个逻辑整体。HTML文本是由HTML命令组成的描述性文本，HTML命令可以说明文字，图形、动画、声音、表格、链接等。层叠样式表(英文全称：Cascading Style Sheets)是一种用来表现HTML（标准通用标记语言的一个应用）或XML（标准通用标记语言的一个子集）等文件样式的计算机语言。CSS不仅可以静态地修饰网页，还可以配合各种脚本语言动态地对网页各元素进行格式化。'},
                {heading:'3. JavaScript程序设计',card:'JavaScript（简称“JS”） 是一种具有函数优先的轻量级，解释型或即时编译型的编程语言。虽然它是作为开发Web页面的脚本语言而出名，但是它也被用到了很多非浏览器环境中，JavaScript 基于原型编程、多范式的动态脚本语言，并且支持面向对象、命令式、声明式、函数式编程范式。'},
                {heading:'4. jQuery程序设计',card:'jQuery是一个快速、简洁的JavaScript框架，是继Prototype之后又一个优秀的JavaScript代码库（框架）于2006年1月由John Resig发布。jQuery设计的宗旨是“write Less，Do More”，即倡导写更少的代码，做更多的事情。它封装JavaScript常用的功能代码，提供一种简便的JavaScript设计模式，优化HTML文档操作、事件处理、动画设计和Ajax交互。'},
                {heading:'5. ElementUI界面设计',card:'Element一套为开发者、设计师和产品经理准备的基于 Vue 2.0 的桌面端组件库。'},
                {heading:'6. Vuejs程序设计',card:'Vue (读音/vjuː/，类似于view) 是一套用于构建用户界面的渐进式JavaScript框架。与其它大型框架不同的是，Vue被设计为可以自底向上逐层应用。Vue的核心库只关注视图层，不仅易于上手，还便于与第三方库或既有项目整合。另一方面，当与现代化的工具链以及各种支持类库结合使用时，Vue 也完全能够为复杂的单页应用（SPA）提供驱动。'}]
            };
        },
        methods: {
            submitForm(formName) 
            {
                this.$refs[formName].validate((valid) => 
                    {
                        if (valid) 
                        {
                            alert('Name:'+this.nameValidateForm.name+';Password:'+this.nameValidateForm.password);
                            // console.log(this.nameValidateForm.name);
                        } else 
                        {
                            console.log('error submit!!');
                            return false;
                        }
                    }
                );
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style>
  .el-card{
    background:#fbfbfb;
    width: 320px;
    display: inline-block;
    margin: 0.3em;
    border-radius:20px;
    height: 300px;
  }
  .cardp{
    text-indent:2em;
    overflow:hidden;
    position:relative;
    text-overflow: ellipsis;
    display: -webkit-box;
    text-align-last:justify;
    -moz-text-align-last: justify ;
    -webkit-text-align-last:justify;
    height: 150px;
    max-height: 150px;
   }  
  .grid-content {
    /* background: rgb(14, 214, 131); */
    border-radius: 4px;
    min-height: 80px;
  }
  .text {
    font-size: 14px;
  }
  .item {
    padding: 18px 0;
  }
  .header-h2{
    color:#d1d1d1 ;
  }
  .header-h2:hover{
    color:#fff ;
  }
  .row-header{
    background:#409eff;
  }
</style>
